<script setup lang="ts">
import type { ChangedField } from '@/generated/logMetadata.types'
import { computed } from 'vue'
import EventActorAvatar from './EventActorAvatar.vue'
import EventRow from './EventRow.vue'
import { eventTimeLabel } from './eventTime'
import FieldChangesPopover from './FieldChangesPopover.vue'
import type { InternalEvent } from './types'

const props = defineProps<{ event: InternalEvent }>()

/**
 * Multi-field variant of FieldChangeRow: renders "{actor} updated" + a
 * "N fields" trigger opening the shared FieldChangesPopover. Used when an event
 * carries a `changedFields` array (organisation_enriched, or a batched
 * field_value_changed) rather than a single field.
 */
const fields = computed(
    () =>
        (props.event.metadata as { changedFields?: ChangedField[] })
            .changedFields ?? []
)
</script>

<template>
    <EventRow>
        <template #leading>
            <EventActorAvatar :actor="event.actor" />
        </template>

        <span class="font-medium">{{ event.actor.displayName }}</span>
        <span>updated</span>
        <FieldChangesPopover :fields="fields" />

        <template #time>{{ eventTimeLabel(event.occurredAt) }}</template>
    </EventRow>
</template>
